/*
封装axios
1.路径：每次都要写成全路径;
2.登录成功之后，如何携带认证信息;
3.请求:post提交的数据格式;
4.响应:response.data.data      response.data.code
*/
import axios from "axios"
import qs from 'qs'

// 创建
let http = axios.create({
    // 基础路径
    baseURL: 'http://localhost:8080/',
    // responseType: "application/json",
    // 是否携带凭证
    withCredentials: true
})

// 拦截器
http.interceptors.request.use(requestConfig => {
    // 允许的请求类型:
    // Content-Type: application/json;charset=UTF-8;  multipart/from-data;  application/x-www-form-urlencoded
    if (requestConfig.method == "post") {
        requestConfig.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        requestConfig.data = qs.stringify(requestConfig.data);
    }
    return requestConfig
})

http.interceptors.response.use(response => {
    return response.data
})

export default http

